import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getGradeList } from "../../actions/Grade.action";
import AddMarkForm from "../../components/AddMarkForm/AddMarkForm";
import Layout from "../../components/shared/Layout/Layout";

const AddMarkPage = ({ edit, grades, getGradeList }) => {
  const { id } = useParams();
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`${edit ? "Edit" : "Add"} Result`}>
        {edit && id && grades ? (
          <AddMarkForm edit={true} grades={grades} />
        ) : (
          <AddMarkForm grades={grades ? grades : []} />
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(AddMarkPage);
